import { capitalize } from 'Data/format.js'

export function toHumanStatus(status) {
  return status
    .split('_')
    .map(el => capitalize(el))
    .join(' ')
}
